import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import {
  CommonMediaQueries,
  IconModule,
  MediaScreenService,
} from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent, LogoComponent } from '@iw/common';
import { AuthService } from '@iw/core/auth-store';
import { ProfileService } from '@iw/core/services';
import { CurrencyRateComponent } from '@iw/currency-rate';
import { UserCardSmallComponent } from '@iw/user-card-small';

@Component({
  selector: 'iw-header',
  imports: [
    LogoComponent,
    UserCardSmallComponent,
    ButtonComponent,
    IconModule,
    TranslateModule,
    CurrencyRateComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  readonly #authService = inject(AuthService);
  readonly #profileService = inject(ProfileService);
  readonly #mediaScreenService = inject(MediaScreenService);

  #isLoggingOut = false;

  readonly userProfile = this.#profileService.profile;
  readonly isDesktop = toSignal(
    this.#mediaScreenService.mediaMatcher(CommonMediaQueries.MD),
  );

  @HostBinding('class.desktop') get desktop() {
    return this.isDesktop();
  }

  logout(): void {
    if (this.#isLoggingOut) {
      return;
    }
    this.#isLoggingOut = true;
    this.#authService.logout();
  }
}
